<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
// @import ../../assets/sass/m3_forms
@import sass/contactForm
</style>

<template>
    <Zone
        :id="$json.contact.id"
        :dataLabel="$json.contact.dataLabel"
        :contrast="contrast"
        class="g_contactForm"
        autoHeight>
        <form id="form" @submit="checkForm">
            <div class="g_row">
                <div
                    v-if="!$breakpoint.isS"
                    class="g_image"
                    v-img-src="{ folder: 'contact', name: 'contact', suffix: false }" />
                <div class="g_form">
                    <Heading
                        v-if="pageIs('contact')"
                        :level="1"
                        v-html="$json.contact.title"/>
                    <Paragraph :content="$json.footer.address" size="XL" />
                    <span class="g_dash">&nbsp;-&nbsp;</span>
                    <Paragraph :content="$json.footer.city" size="XL" />
                    <div class="g_cta g_cta1">
                        <Paragraph
                            :content="$json.footer.fixe.extra + ':&nbsp;'"
                            size="L" />
                        <Cta
                            type="text"
                            class="g_link"
                            :link="$json.footer.fixe.link"
                            target="_blank"
                            :content="$json.footer.fixe.cta" />
                        <span class="g_dash">&nbsp;-&nbsp;</span>
                        <Paragraph
                            :content="$json.footer.mobile.extra + ':&nbsp;'"
                            size="L" />
                        <Cta
                            type="text"
                            class="g_link"
                            :link="$json.footer.mobile.link"
                            target="_blank"
                            :content="$json.footer.mobile.cta" />
                    </div>
                    <div class="g_cta">
                        <Cta
                            type="text"
                            class="g_link"
                            :link="mailto + email"
                            target="_blank"
                            :content="email" />
                    </div>
                    <div class="g_civilite">
                        <div class="g_radio">
                            <Paragraph :content="$json.contact.form.civilite.label" size="L" :class="'g_label'"/>
                            <div class="g_table">
                                <div v-for="(radio, j) in $json.contact.form.civilite.radios" :key="j" class="g_radioItem">
                                    <input :id="radio.id" type="radio" name="civilite" :value="radio.value" v-model="fields.civilite" />
                                    <label :for="radio.id" v-html="radio.value"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="g_lastname g_visually_hidden">
                        <div class="g_field">
                            <label for="lastname" class="g_txt_L" v-html="'Prenom'" :class="'g_label'" />
                            <input id="lastname" name="lastname" v-model="fields.lastname" type="text" />
                        </div>
                    </div>
                    <div class="g_name">
                        <div class="g_field" :class="[$json.contact.form.name.required ? 'g_required' : '']">
                            <label for="name" class="g_txt_L" v-html="$json.contact.form.name.label" :class="'g_label'" />
                            <input id="name" name="name" v-model="fields.name" type="text" :class="[!errors.name ? '' : 'g_error']" />
                            <span v-html="errors.name" />
                        </div>
                    </div>
                    <div class="g_tel">
                        <div class="g_field" :class="[$json.contact.form.tel.required ? 'g_required' : '']">
                            <label for="tel" class="g_txt_L" v-html="$json.contact.form.tel.label" :class="'g_label'" />
                            <input id="tel" name="tel" v-model="fields.tel" type="tel" :class="[!errors.tel ? '' : 'g_error']" />
                            <span v-html="errors.tel" />
                        </div>
                    </div>
                    <div class="g_email">
                        <div class="g_field" :class="[$json.contact.form.email.required ? 'g_required' : '']">
                            <label for="email" class="g_txt_L" v-html="$json.contact.form.email.label" :class="'g_label'" />
                            <input id="email" name="email" v-model="fields.email" type="text" :class="[!errors.email ? '' : 'g_error']" />
                            <span v-html="errors.email" />
                        </div>
                    </div>
                    <div class="g_confirm">
                        <div class="g_field" :class="[$json.contact.form.confirm.required ? 'g_required' : '']">
                            <label for="confirm" class="g_txt_L" v-html="$json.contact.form.confirm.label" :class="'g_label'" />
                            <input id="confirm" name="confirm" v-model="fields.confirm" type="text" :class="[!errors.confirm ? '' : 'g_error']" />
                            <span v-html="errors.confirm" />
                        </div>
                    </div>
                    <div class="g_etablissement">
                        <div class="g_field" :class="[$json.contact.form.etablissement.required ? 'g_required' : '']">
                            <label for="etablissement" class="g_txt_L" v-html="$json.contact.form.etablissement.label" :class="'g_label'" />
                            <input id="etablissement" name="etablissement" v-model="fields.etablissement" type="text" :class="[!errors.etablissement ? '' : 'g_error']" />
                            <span v-html="errors.etablissement" />
                        </div>
                    </div>
                    <div class="g_type">
                        <div class="g_radio">
                            <Paragraph :content="$json.contact.form.type.label" size="L" :class="'g_label'"/>
                            <div class="g_table">
                                <div v-for="(radio, j) in $json.contact.form.type.radios" :key="j" class="g_radioItem">
                                    <input :id="radio.id" type="radio" name="type" :value="radio.value" v-model="fields.type" />
                                    <label :for="radio.id" v-html="radio.value"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="g_souhait">
                        <div class="g_radio">
                            <Paragraph :content="$json.contact.form.souhait.label" size="L" :class="'g_label'"/>
                            <div class="g_table">
                                <div v-for="(radio, j) in $json.contact.form.souhait.radios" :key="j" class="g_radioItem">
                                    <input :id="radio.id" type="radio" name="souhait" :value="radio.value" v-model="fields.souhait" />
                                    <label :for="radio.id" v-html="radio.value"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="g_comment">
                        <div class="g_textarea">
                            <label for="comment" class="g_txt_L" v-html="$json.contact.form.comment.label" :class="'g_label'" />
                            <textarea id="comment" name="comment" v-model="fields.comment" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="g_submit">
                <div>
                    <input type="submit" name="submit" :value="$json.config.form.submit.label" class="g_btn g_btnBuy" />
                </div>
            </div>
        </form>
        <template v-if="!error">
            <Paragraph v-if="!warning && !sended && !isSending && !isChecking" :content="$json.config.form.mandatory" size="M" />
            <Paragraph v-else-if="isChecking" :content="$json.config.form.checking" size="M" />
            <Paragraph v-else-if="warning" :content="$json.config.form.warning" size="M" class="g_warning" />
            <Paragraph v-else-if="isSending" :content="$json.config.form.sending" size="M" />
            <Paragraph v-else-if="sended" :content="$json.config.form.success" size="M" />
        </template>
        <template v-else>
            <Paragraph :content="$json.config.form.error" size="M" class="g_warning" />
        </template>
        <div class="g_personnal" :class="{'g_opened' : isOpen}">
            <Cta
                type="button"
                class="g_link"
                @click="openClose"
                :content="$json.config.form.disclaimer" />
            <Paragraph :content="$json.config.form.personnal" size="S" />
        </div>
    </Zone>
</template>

<script>
import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)

export default {
    name: 'ContactForm',
    props: {
        contrast: {
            type: String,
            default: 'light'
        }
    },
    data () {
        return {
            mailtoBase64: 'bWFpbHRvOg==',
            mailto: '',
            emailBase64: 'Y29udGFjdEBtMy1jb21tdW5pY2F0aW9uLmZy',
            email: '',
            errors: {
                name: null,
                tel: null,
                email: null,
                confirm: null,
                etablissement: null
            },
            fields: {
                lastname: '',
                civilite: '',
                name: '',
                tel: '',
                email: '',
                confirm: '',
                etablissement: '',
                type: '',
                souhait: '',
                comment: ''
            },
            form: new FormData(),
            warning: false,
            isChecking: false,
            isSending: false,
            sended: false,
            error: false,
            isOpen: false
        }
    },
    mounted () {
        setTimeout(() => {
            this.mailto = atob(this.mailtoBase64)
            this.email = atob(this.emailBase64)
        }, 500)
    },
    methods: {

        pageIs (page) {
            return this.$landing.project === page
        },
        openClose () {
            this.isOpen = !this.isOpen
        },
        checkForm (e) {
            e.preventDefault()

            this.isChecking = true

            this.has('name')
            this.has('tel')
            this.hasEmail('email', 'confirm')
            this.has('etablissement')

            setTimeout(() => {
                if (this.has('name') && this.has('tel') && this.hasEmail('email', 'confirm') && this.has('etablissement')) {
                    this.isChecking = false
                    this.warning = false
                    this.submit()
                    return true
                } else {
                    this.isChecking = false
                    this.warning = true
                    return false
                }
            }, 1000)
        },
        clearForm () {
            for (let field in this.fields) {
                this.fields[field] = ''
            }
        },
        submit () {
            this.isSending = true

            setTimeout(() => {
                // Build for data
                for (let field in this.fields) {
                    console.log(field, this.fields[field])
                    this.form.append(field, this.fields[field])
                }

                // Send form to server
                this.$http.post('/contact.php', this.form).then((response) => {
                    console.log(this.form)
                    // console.log(response)
                    this.clearForm()
                    this.isSending = false
                    this.sended = true
                }).catch((e) => {
                    // console.log(e)
                    this.isSending = false
                    this.error = true
                })
            }, 1000)
        },
        has (id) {
            let value = this.fields[id]
            this.errors[id] = ''

            if (!value) {
                this.errors[id] = 'Merci de remplir ce champ'
            }
            return !!value
        },
        hasEmail (id1, id2) {
            let value1 = this.fields[id1]
            let value2 = this.fields[id2]
            this.errors[id1] = ''
            this.errors[id2] = ''
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

            if (!value1) {
                this.errors[id1] = 'Merci de remplir ce champ'
                return false
            } else if (!re.test(value1)) {
                this.errors[id1] = 'Email non valide'
                return false
            }

            if (!value2) {
                this.errors[id2] = 'Merci de remplir ce champ'
                return false
            } else if (!re.test(value2)) {
                this.errors[id2] = 'Email non valide'
                return false
            }

            if (re.test(value1) && re.test(value2) && (value1 === value2)) {
                return true
            } else {
                this.errors[id1] = this.errors[id2] = 'Les valeurs ne correspondent pas'
                return false
            }
        }
    }
}
</script>
